<!-- Footer -->
<div class="d-flex flex-wrap gap-2 justify-content-between align-items-center p-3 border-top">

    <div class="small text-muted" *ngIf="counts?.totalRows; else noData">
        Showing {{ startRow }} to {{ endRow }} of {{ counts?.totalRows }}
    </div>

    <div class="d-flex gap-2">
        <!-- First -->
        <button class="btn btn-outline-secondary btn-sm" [disabled]="!counts || counts.currentPage <= 1"
            [routerLink]="[link]" [queryParams]="buildQueryParams(1)" queryParamsHandling="merge"
            (click)="route(1)">
            First
        </button>

        <!-- Prev -->
        <button class="btn btn-outline-secondary btn-sm" [disabled]="!counts || counts.currentPage <= 1"
            [routerLink]="[link]" [queryParams]="buildQueryParams(prev)" queryParamsHandling="merge"
            (click)="route(prev)">
            Prev
        </button>

        <!-- Numbers -->
        <button *ngFor="let i of range"
            type="button"
            class="btn btn-sm"
            [ngClass]="i === counts!.currentPage 
            ? 'btn-secondary' 
            : 'btn-outline-secondary'"
            [disabled]="i === counts!.currentPage"
            [routerLink]="[link]"
            [queryParams]="buildQueryParams(i)"
            (click)="route(i)">
            {{ i }}
        </button>

        <!-- Next -->
        <button class="btn btn-outline-secondary btn-sm" [disabled]="!counts || counts.currentPage >= counts.totalPages"
            [routerLink]="[link]" [queryParams]="buildQueryParams(next)" queryParamsHandling="merge"
            (click)="route(next)">
            Next
        </button>

        <!-- Last -->
        <button class="btn btn-outline-secondary btn-sm" [disabled]="!counts || counts.currentPage >= counts.totalPages"
            [routerLink]="[link]" [queryParams]="buildQueryParams(counts!.totalPages)" queryParamsHandling="merge" (click)="route(counts!.totalPages)">
            Last
        </button>
    </div>
</div>

<ng-template #noData>
    <div class="small text-muted">No records found</div>
</ng-template>